export function isCollection100PercentEnabled(collection100Percent) {
    return collection100Percent === true || collection100Percent === 'true';
}

export function isFutureDate(dateValue, now = new Date()) {
    if (!dateValue) {
        return false;
    }
    const date = new Date(dateValue);
    const today = new Date(now);
    date.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return date > today;
}

export function isFutureMonth(monthData, now = new Date()) {
    if (!monthData) {
        return false;
    }
    const year = Number(monthData.year);
    const month = Number(monthData.month);
    if (!Number.isFinite(year) || !Number.isFinite(month)) {
        return false;
    }
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;
    return year > currentYear || (year === currentYear && month > currentMonth);
}

export function filterFutureMonthsForCollection100(payments, collection100Percent) {
    if (!isCollection100PercentEnabled(collection100Percent)) {
        return payments || [];
    }
    return (payments || []).filter(payment => !isFutureMonth(payment));
}
